import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';

const AlertPopup = (props) => {
  return (
    <Container fluid>
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center'>
          <Image src={props.icon} alt='התראה' />
        </Row>
        <Row className='justify-content-center'>
          <span className='title'>{props.title}</span>
        </Row>
        <Row className='justify-content-center'>
          <span className='content'>{props.content}</span>
        </Row>
      </div>
      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

export default AlertPopup;
